import SubLabel from "components/Atoms/Sublabel";
import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";

const PromoterList = (props: PickerListProps<server.dto.CompanySmall>) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedPromoterInstruction>({
    page: 1,
    perPage: 20,
    keyword: "",
  });

  return <>
    <PickerList
      instruction={instruction}
      onInstructionChange={setInstruction}
      queryKey="promoterlist"
      api={window.CoreApi.Promoter.PaginatedSmall}
      onClick={props.onItemSelected}
      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      getId={promoter => promoter.companyId}
      renderListItem={promoter => <>
        <div>{promoter.name}</div>
        <SubLabel>{promoter.cityCountry}</SubLabel>
      </>}
    />
  </>;
};

export default PromoterList;